module.exports = __webpack_public_path__ + "static/media/feg-honors-desktop.6fbbc9eb.png";